import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { Button, Container, Separator, Title, Toolbar } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

import GoalTemplateSelector from './GoalTemplateSelector';
import { useHistory } from '@treams/treams-routes';
import RemainingGoalsStatus from 'goals/RemainingGoalsStatus';

const Background = styled(Box)`
	background: ${(props) => props.theme.colors.whiteBlue};
`;

export default function GoalTemplates(props: {
	userID: string;
	returnURL: string;
	onScratch: () => void;
}) {
	const history = useHistory();
	const momentID = new URLSearchParams(history.location.search).get('moment_id') ?? undefined;

	const { t } = useTranslation();

	const [template, setTemplate] = useState<graphql.GoalTemplate | null | undefined>(undefined);

	return (
		<>
			<Container py={4}>
				{momentID && <RemainingGoalsStatus momentID={momentID} />}
				<Title>{t('goals.edit.toolbar.templates.title')}</Title>
			</Container>
			<Separator />
			<Background>
				<Container py={4}>
					<GoalTemplateSelector
						userID={props.userID}
						template={template}
						onChange={setTemplate}
						onLoad={(templates) => {
							if (templates.length === 0) {
								props.onScratch();
							}
						}}
					/>
				</Container>
			</Background>
			<Separator />
			<Container py={4}>
				<Toolbar>
					<Toolbar.Spacing />
					<Button link={props.returnURL} title={t('goals.edit.toolbar.cancel')} type="secondary" />
					<Button
						disabled={template === undefined}
						onClick={() => {
							if (!template) {
								props.onScratch();
							} else {
								const params = new URLSearchParams(history.location.search);
								params.set('template_id', template.id);
								history.push(history.location.pathname + '?' + params.toString());
							}
						}}
						title={t('goals.edit.toolbar.next')}
						type="primary"
					/>
				</Toolbar>
			</Container>
		</>
	);
}
